export default __webpack_public_path__ + "static/media/3132 knife block A side.93fc2642.png";